import { render, staticRenderFns } from "./BooksEdit.vue?vue&type=template&id=fca7ef1a&scoped=true&"
import script from "./BooksEdit.vue?vue&type=script&lang=js&"
export * from "./BooksEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca7ef1a",
  null
  
)

export default component.exports